import React,{useState,useEffect} from 'react'
import { totalDepositList } from 'network/ApiAxiosTickets';

function DepositToShop(props) {
    const [money, setMoney] = useState(0);
    let userID = JSON.parse(localStorage.getItem("user"))._id;
    let userName = JSON.parse(localStorage.getItem("user")).name;
    useEffect(() => {
        fetchSellerDeposits()
    }, []);

    const fetchSellerDeposits = async()=>{
        const resp = await totalDepositList()
        if(resp.data.success){
            if(props?.reseller){
              setMoney(resp.data.resultFinalReseller.sellerName[userName])
            }else{
              setMoney(resp.data.resultFinal.sellerName[userName])
            }
        }
    }
  return (
    money ?
      <>
        <h2 className='text-center' style={{fontSize:'2rem'}}> { money } €</h2>
      </> : null
  )
}

export default DepositToShop